/**
 * Pure helpers for resolving entity references safely when linked
 * employees/services may have been deleted without cascade cleanup.
 */

export function getServiceResourceIds(servicesById, serviceId) {
  const service = servicesById && servicesById[serviceId];
  if (!service || !Array.isArray(service.resources)) {
    return [];
  }
  return service.resources;
}

export function resolveResourcesById(resourceIds, resourcesById) {
  return (resourceIds || [])
    .map((id) => resourcesById[id])
    .filter(Boolean);
}

export function filterOnlineBookableResources(resources) {
  return resources.filter(
    (resource) => resource && resource.availableForOnlineBookings
  );
}

export function sortShopServices(servicesList) {
  return (servicesList || [])
    .filter(
      (service) =>
        service &&
        typeof service.name === "string" &&
        service.availableForOnlineBookings
    )
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function getEmployeeDisplayName(employeesById, employeeId) {
  const employee = employeesById && employeesById[employeeId];
  return employee ? employee.name : "(removed employee)";
}

export function isEmployeePresent(employeesById, employeeId) {
  return !!(employeesById && employeesById[employeeId]);
}

export function mergeBookingsAvailability(availabilityList) {
  if (!availabilityList || !availabilityList.length) {
    return {};
  }

  return availabilityList.reduce((merged, next) => {
    for (const date in next) {
      if (date in merged) {
        merged[date] = Array.from(
          new Set([...next[date], ...merged[date]])
        ).sort();
      } else {
        merged[date] = next[date];
      }
    }
    return merged;
  }, {});
}

export function sortAvailabilityByDate(availability) {
  const sorted = {};
  Object.keys(availability || {})
    .sort()
    .forEach((key) => {
      sorted[key] = availability[key];
    });
  return sorted;
}